export default __webpack_public_path__ + "static/media/wallet.685d9bce.svg";